import { combineReducers } from "redux";
import storeReducer from "./Store/index";
import userReducer from "./Authentication";
import selectedStore from "./Store/selectedStore";
import storeLists from "./Store/list";
import listItems from "./Store/item";
import userProfile from "./Profile/profile";
import themeColor from "./Theme/theme";
import otp from "./Authentication/otp";
const rootReducer = combineReducers({
  storeReducer,
  userReducer,
  selectedStore,
  storeLists,
  listItems,
  userProfile,
  themeColor,
  otp,
});

export default rootReducer;
